import Icon, { IProps } from '../../Icon';

export default function Sprout(props: Omit<IProps, 'icon'>) {
  return <Icon icon="sprout-logo" data-testid="moneytree-icon" {...props} />;
}
